import type { SummaryFilter } from 'services/recipes/types';

export const recipesSummaryCacheKey = (
  searchTerm: string,
  sortBy: string,
  pageNumber: number,
  filters: SummaryFilter[],
) => ['recipes/summary', searchTerm, sortBy, pageNumber, filters] as const;
